<template><!-- svgo-optimised -->
<svg class="icon icon__pipe" viewBox="0 0 1 16" xmlns="http://www.w3.org/2000/svg"><path d="M.25 0v16" stroke="#000" stroke-width=".5"/></svg></template>